// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { NewlyRegisteredUser } from "../users/types";

interface paramsType {
  user: NewlyRegisteredUser;
  interval?: NodeJS.Timer;
}

export function useLimitedPingMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function limitedPing(params: paramsType): Promise<any> {
    const response = await api.get<any>(
      "auth/limitedping",
      {},
      {
        headers: {
          Authorization: `Bearer ${params.user.token.value}`,
        },
      }
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: limitedPing,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
